import AvatarBlock from "./avatar-block";

export default AvatarBlock;